"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Highlight_1 = require("../Highlight/Highlight");
var Icon_1 = require("../Icon/Icon");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Typography_1 = require("../Typography/Typography");
var TextIcon_style_1 = __importDefault(require("./TextIcon.style"));
/**
 * TextIcon atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-texticon--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/TextIcon Source}
 */
var TextIcon = function (_a) {
    var _b;
    var className = _a.className, icon = _a.icon, _c = _a.iconMargin, iconMargin = _c === void 0 ? 'default' : _c, color = _a.color, text = _a.text, textToHighlight = _a.textToHighlight, bold = _a.bold, fontVariant = _a.fontVariant, textColor = _a.textColor, numberOfLines = _a.numberOfLines, tooltip = _a.tooltip, other = __rest(_a, ["className", "icon", "iconMargin", "color", "text", "textToHighlight", "bold", "fontVariant", "textColor", "numberOfLines", "tooltip"]);
    var classes = (0, TextIcon_style_1.default)();
    var iconClassName = (0, classnames_1.default)((_b = {},
        _b[classes.denseIconMargin] = (iconMargin === 'default' && text) || iconMargin === 'dense',
        _b[classes.attributeMargin] = (iconMargin === 'default' && !text) || iconMargin === 'wide',
        _b));
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.container, className) }, { children: [renderIcon(), renderText()] })));
    function renderIcon() {
        if (isIconPathProps(icon)) {
            return (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ iconPath: icon, color: color || theme_1.default.colors.dark, className: iconClassName }, other));
        }
        return icon;
    }
    function renderText() {
        return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ color: textColor, noWrap: !numberOfLines, variant: fontVariant, bold: bold, numberOfLines: numberOfLines, onClick: other.onClick }, { children: (0, jsx_runtime_1.jsx)(Highlight_1.Highlight, { text: text, textToHighlight: textToHighlight }) })) })));
    }
};
exports.TextIcon = TextIcon;
function isIconPathProps(icon) {
    return !!icon && typeof icon === 'object' && 'path' in icon;
}
